<template>
  <div class="text-center">
    <img
      src="@/assets/img/logo/karyatama-logo.png"
      alt="Karyawama logo"
      class="logo"
    /><br />
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(login)">
        <div class="form-input">
          <ValidationProvider
            v-slot="{ errors }"
            name="No. BA"
            rules="required"
          >
            <div class="field-container">
              <label class="field-label">4 No.BA terakhir</label>
              <v-text-field
                v-model="username"
                :error-messages="errors"
                outlined
                dense
              >
                <template v-slot:prepend-inner>
                  <span>121050000</span>
                  <div class="icon-input">
                    <v-icon size="20">mdi-account</v-icon>
                  </div>
                </template>
              </v-text-field>
            </div>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            name="Password"
            rules="required"
          >
            <v-text-field
              v-model="password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              :error-messages="errors"
              label="Password"
              @click:append="show1 = !show1"
            ></v-text-field>
          </ValidationProvider>
        </div>
        <v-btn
          type="submit"
          color="#EE4037"
          :loading="loading"
          block
          dark
          class="button-login"
          >Login</v-btn
        >
      </v-form>
    </ValidationObserver>
    <!-- dialog failed -->
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
        <v-card-title class="title-card mx-auto">Login failed</v-card-title>
        <p class="text-center">{{ errorMessage }}</p>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="dialog = false"
            color="#EE4037"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  data() {
    return {
      show1: false,
      username: null,
      password: null,
      errorMessage: null,
      loading: false,
      dialog: false,
      formInput: []
    };
  },
  methods: {
    setPage() {
      this.$emit("signup", false);
    },
    forgotPass() {
      this.$router.push("/forgot-password");
    },
    login() {
      this.loading = true;
      let userlogin;
      if (!this.username.includes("dev")) {
        userlogin = 121050000 + this.username;
      } else {
        userlogin = this.username;
      }
      this.formInput = {
        noa: userlogin,
        username: userlogin,
        password: this.password
      };
      this.$store.commit("login/SET_DATALOGIN", this.formInput);
      this.$store
        .dispatch("login/sendLogin")
        .then(response => {
          const res = response;
          console.log(res);
          if (res.status === 200) {
            Cookies.set("token", res.data.data.token, { expires: 1 });
            this.loading = false;
            this.$router.go();
          } else {
            this.loading = false;
            this.dialog = true;
          }
        })
        .catch(error => {
          const message = error.response.data.message;
          console.log(message);
          if (error.response.status === 400) {
            this.errorMessage = message;
            this.dialog = true;
            this.loading = false;
          } else {
            this.errorMessage = message;
            this.dialog = true;
            this.loading = false;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  width: 40%;
}
.app-title {
  margin-bottom: 10px;
  font-weight: bold;
}

.button-login {
  margin-top: 20px;
}

.v-form {
  color: #cccccc !important;
}

.text-blue {
  cursor: pointer;
}

.text-blue:hover {
  color: rgb(9, 82, 141);
}
</style>
